import api from 'modules/api/index';

export const getTransferDetailsRequest = (payload) => {
  return api.get('/hyperwallet/transfer-details', { params: payload });
};

export const getUserStatusRequest = (payload) => {
  return api.get('/hyperwallet/user-status', { params: payload });
};
